import React, { useContext } from "react";
import { Dialog, DialogContent } from "@mui/material";
import { CloseOutlined } from "@ant-design/icons";
import "../css/AddNewFBODialog.css";
import { StorageContext } from "../../services/StorageProvider";
import { FBO_ROLE_CODES } from "../../utils/constants";

const FBOUserProfileDialog = ({ open, onClose }) => {
  const { fboUserProfileData, airportListData } = useContext(StorageContext);

  function getAirportAccess(data) {
    const airportId = data?.associations[0]?.fboCustomer?.airportId;
    const airport = airportListData?.find(
      (airport) => airport?.id === airportId
    );
    return airport?.name;
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        className: "add-new-fbo-dialog-container",
      }}
    >
      <DialogContent>
        <CloseOutlined className="add-new-fbo-dialog-close" onClick={onClose} />
        <div className="add-new-fbo-dialog-content">
          <div className="add-new-fbo-dialog-title">Profile</div>
          <div className="add-new-fbo-input-container">
            <label>Name</label>
            <div className="add-new-fbo-non-editable-field">{`${fboUserProfileData?.firstName} ${fboUserProfileData?.lastName}`}</div>
          </div>
          <div className="add-new-fbo-input-container">
            <label>ABO Name</label>
            <div className="add-new-fbo-non-editable-field">
              {fboUserProfileData?.associations[0]?.fboCustomer?.name}
            </div>
          </div>
          <div className="add-new-fbo-input-container">
            <label>ABO Role</label>
            <div className="add-new-fbo-non-editable-field">
              {fboUserProfileData?.associations[0]?.role === FBO_ROLE_CODES.FBO_ADMIN
                ? "ABO Admin"
                : "ABO Employee"}
            </div>
          </div>
          <div className="add-new-fbo-input-container">
            <label>Email</label>
            <div className="add-new-fbo-non-editable-field">
              {fboUserProfileData?.email}
            </div>
          </div>
          <div className="add-new-fbo-input-container">
            <label>Airport Access</label>
            <div className="add-new-fbo-non-editable-field">
              {getAirportAccess(fboUserProfileData)}
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default FBOUserProfileDialog;
